import { DatastoreType, DatastoreTypeEnum } from "../../types";
import {
  AzureDatabricksConnection,
  AzureDatabricksPrivateLinkConnection,
  DatabricksConnection,
  DbtCloudConnection,
  DbtCoreConnection,
  PostgresConnection,
  SnowflakeConfiguration,
  SnowflakeConnection,
  TableauConnection,
} from "./DatastoreConnections";

export interface TypeData {
  name: string;
  type: DatastoreType;
  description: string;
  connection?: Record<string, unknown>;
}

export const getConnectionPageByType = (
  typeData: TypeData,
  handleBack: () => void,
  handleConnectionSubmit?: (data: Record<string, unknown>) => void
): JSX.Element => {
  switch (typeData?.type) {
    case DatastoreTypeEnum.SNOWFLAKE:
      return (
        <SnowflakeConnection
          typeData={typeData}
          handleBack={handleBack}
          handleConnectionSubmit={handleConnectionSubmit}
        />
      );
    case DatastoreTypeEnum.POSTGRES:
      return <PostgresConnection typeData={typeData} handleBack={handleBack} />;
    case DatastoreTypeEnum.TABLEAU:
      return (
        <TableauConnection
          typeData={typeData}
          handleBack={handleBack}
          handleConnectionSubmit={handleConnectionSubmit}
        />
      );
    case DatastoreTypeEnum.DBT_CLOUD:
      return (
        <DbtCloudConnection
          typeData={typeData}
          handleBack={handleBack}
          handleConnectionSubmit={handleConnectionSubmit}
        />
      );
    case DatastoreTypeEnum.DBT_CORE:
      return <DbtCoreConnection typeData={typeData} handleBack={handleBack} />;
    case DatastoreTypeEnum.AZURE_DATABRICKS:
      return <AzureDatabricksConnection typeData={typeData} handleBack={handleBack} />;
    case DatastoreTypeEnum.AZURE_DATABRICKS_PRIVATE_LINK:
      return <AzureDatabricksPrivateLinkConnection typeData={typeData} handleBack={handleBack} />;
    case DatastoreTypeEnum.DATABRICKS:
      return <DatabricksConnection typeData={typeData} handleBack={handleBack} />;
    default:
      return <div>Coming Soon...</div>;
  }
};

export const getConfigurationPageByType = (
  typeData: TypeData,
  handleBack: () => void
): JSX.Element => {
  switch (typeData?.type) {
    case DatastoreTypeEnum.SNOWFLAKE:
      return <SnowflakeConfiguration typeData={typeData} handleBack={handleBack} />;
    default:
      return <div>Coming Soon...</div>;
  }
};
